import { Outlet, Navigate } from 'react-router-dom'
import { ShieldCheck, CheckCircle2 } from 'lucide-react'
import { useAuthStore } from '@/store/auth'

export function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuthStore()

  if (isLoading) return null

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="flex min-h-screen bg-white">
      {/* Left Side - Brand & Value Proposition (Dark Navy) */}
      <div className="hidden lg:flex lg:w-1/2 flex-col bg-slate-900 relative overflow-hidden text-white p-12 justify-between">

        {/* Abstract Background Pattern */}
        <div className="absolute inset-0 opacity-10"
             style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }}>
        </div>

        <div className="relative z-10">
            <div className="flex items-center gap-3 mb-12">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-800 border border-slate-700">
                    <ShieldCheck className="h-6 w-6 text-white" />
                </div>
                <span className="text-xl font-bold tracking-tight">NexScribe <span className="opacity-50 font-normal">Enterprise</span></span>
            </div>

            <h1 className="text-5xl font-bold leading-tight mb-6">
                Secure Intelligence for <br/>
                <span className="text-emerald-400">Modern Leaders.</span>
            </h1>
            <p className="text-lg text-slate-400 max-w-md leading-relaxed">
                Join 10,000+ executives using NexScribe to automate meeting minutes, enforce compliance, and drive action.
            </p>
        </div>

        {/* Feature List / Trust Signals */}
        <div className="relative z-10 space-y-4">
            {[
                'SOC2 Type II Compliant Environment',
                'End-to-End AES-256 Encryption',
                'GDPR & CCPA Ready',
                '99.9% Uptime SLA'
            ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                    <CheckCircle2 className="h-5 w-5 text-emerald-500" />
                    <span className="font-medium text-slate-300">{item}</span>
                </div>
            ))}
        </div>
      </div>

      {/* Right Side - Forms */}
      <div className="flex-1 flex flex-col justify-center items-center p-6 lg:p-12 bg-slate-50 relative">
        <div className="w-full max-w-md">
            {/* Mobile Logo */}
            <div className="lg:hidden flex justify-center mb-8">
                <div className="h-10 w-10 bg-slate-900 rounded-xl flex items-center justify-center shadow-lg">
                    <ShieldCheck className="h-6 w-6 text-white" />
                </div>
            </div>

            <Outlet />
        </div>

        {/* Footer Links */}
        <div className="absolute bottom-6 text-center w-full text-xs text-slate-400">
            Protected by reCAPTCHA and subject to the Privacy Policy and Terms of Service.
        </div>
      </div>
    </div>
  )
}
